const EMAIL_LINK_LOGIN_QUERY_PARAM = 'checkout_email_link_login';

export const getEmailLoginLinkUrlRedirect = (): string => {
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.set(EMAIL_LINK_LOGIN_QUERY_PARAM, 'true');
    searchParams.delete('requestPasswordEmail');

    return `${window.location.pathname}?${searchParams.toString()}`;
};
